export default __webpack_public_path__ + "static/media/Foto3.166b0e79.png";